import {
    GET_TODAY_COUNT_LOG,
    GET_TODAY_COUNT_LOG_SUCCESS,
    GET_TODAY_COUNT_LOG_ERROR
} from "./actions";


const INIT_STATE = {
    car_log: [],
    people_log: [],
    error: "",
    totalPeopleCount_in: 0,
    totalPeopleCount_out: 0,
    totalCarCount_in: 0,
    totalCarCount_out: 0,
    sectorwisePeople_in: [],
    sectorwiseCar_in: [],
    sectorwisePeople_out: [],
    sectorwiseCar_out: [],
    peopleCountTimeIn: [],
    peopleCountTimeOut: [],
    carCountTimeIn: [],
    carCountTimeOut: [],
    timeLabelsTime: [],
    totalSectors: [],
    count_loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TODAY_COUNT_LOG:
            return {
                ...state,
                count_loading: true,
                error: ""
            };
        case GET_TODAY_COUNT_LOG_SUCCESS:
            return {
                ...state,
                totalPeopleCount_in: action.payload.totalPeopleCount_in,
                totalPeopleCount_out: action.payload.totalPeopleCount_out,
                totalCarCount_in: action.payload.totalCarCount_in,
                totalCarCount_out: action.payload.totalCarCount_out,
                sectorwisePeople_in: action.payload.sectorwisePeople_in,
                sectorwiseCar_in: action.payload.sectorwiseCar_in,
                sectorwisePeople_out: action.payload.sectorwisePeople_out,
                sectorwiseCar_out: action.payload.sectorwiseCar_out,
                peopleCountTimeIn: action.payload.peopleCountTimeIn,
                peopleCountTimeOut: action.payload.peopleCountTimeOut,
                carCountTimeIn: action.payload.carCountTimeIn,
                carCountTimeOut: action.payload.carCountTimeOut,
                timeLabelsTime: action.payload.timeLabelsTime,
                totalSectors: action.payload.totalSectors,
                error: ""
            };
        case GET_TODAY_COUNT_LOG_ERROR:
            return {
                ...state,
                count_loading: false,
                error: action.payload
            };
        default:
            return {
                ...state
            };
    }
};
